import Image from 'next/future/image';
import { useRouter } from 'next/router';
import { useContext, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import PromotionDropdown from '@/components/dropdowns/unit-promotions';
import HeaderFooterContext from '@/context/HeaderFooterContext';
import { formatAsPrice } from '@/helper/formatAsPrice';
import phone from '@/public/images/icons/phone-incoming-01.svg';
import playIcon from '@/public/images/icons/play-icon.svg';
import { MINIMUM_UNITS, UNITS_LEFT } from '@/utils/constants';

import style from './store.module.scss';

const SingleUnitCard = (props: any) => {
  const { item, showDimensions } = props;
  const [show, setShow] = useState(false);
  const [selectedPromotion, setSelectedPromotion] = useState(null);
  const [promotionError, setPromotionError] = useState(false);
  const [toggle, setToggle] = useState(null);
  const [target, setTarget] = useState(null);
  const [displayPromotion, setDisplayPromotion] = useState(null);
  const promotionList = item?.promotionList;

  const handleClose = () => setShow(false);
  const headerFooterData = useContext(HeaderFooterContext);
  const { locale } = useRouter();
  const { facilityId } = headerFooterData;
  const handleShow = () => {
    setShow(true);
  };
  const handleCeiling = () => {
    if (facilityId === 'L086') {
      return <FormattedMessage id="filters.2ftceiling" />;
    }
    if (facilityId === 'L030' || facilityId === 'L022') {
      return <FormattedMessage id="filters.3ftceiling" />;
    }
    return <FormattedMessage id="filters.4ftceiling" />;
  };

  const handlePromotionSelect = (promotion: any) => {
    setSelectedPromotion(promotion);
    setPromotionError(false);
    setTarget('#requestCallbackModal');
    setToggle('modal');
    if (promotion) {
      const rate = item?.rate;
      const tempPromotionRate = rate - (rate * promotion.discount) / 100;
      setDisplayPromotion(formatAsPrice(tempPromotionRate, locale, false));
    }
  };

  const handleClick = (event: any, facility: any, formType: string) => {
    if (!selectedPromotion) {
      event.preventDefault();
      setPromotionError(true);
      return;
    }
    const obj = {
      unitRate: facility.rate,
      dimensions: `${facility?.dimensions?.width} x ${facility?.dimensions?.length}`,
      facilityID: headerFooterData.facilityId,
      unitTypeId: facility.unitTypeId,
      PromotionSLName: selectedPromotion?.slName,
      promotionDescription:
        locale === 'fr' ? selectedPromotion?.fr : selectedPromotion?.en,
      consessionId: selectedPromotion?.concessionID,
      unitWidth: facility?.dimensions?.width,
      unitLength: facility?.dimensions?.length,
      formType,
    };

    headerFooterData.setViewUnit(obj);
  };

  const UnitFeatures = () => {
    return (
      <div className={style.unitFeatures}>
        {item?.hasAmenities?.miniLocker ? handleCeiling() : ''}
        {item?.hasAmenities?.heated ? (
          <div>
            <FormattedMessage id="filters.heated" />
          </div>
        ) : (
          ''
        )}{' '}
        {item?.hasAmenities?.driveUp ? (
          <div>
            <FormattedMessage id="filters.driveup" />
          </div>
        ) : (
          ''
        )}
        {item?.hasAmenities?.climateControlled ? (
          <div>
            <FormattedMessage id="filters.climateControlled" />
          </div>
        ) : (
          ''
        )}
        {/* </p> */}
      </div>
    );
  };

  return (
    <div>
      <div className={style.unitContainer}>
        <div className={style.imageContainer}>
          {item.image && (
            <img
              src={item?.image}
              alt="Unit image"
              className={`${style.unitImage}`}
            />
          )}
          {item?.videoUrl && (
            <Image
              src={playIcon || ''}
              alt="play"
              width="25"
              height="25"
              onClick={handleShow}
              className={`${style.unitVideoPlay}`}
            ></Image>
          )}
        </div>
        <div className={style.detailsContainer}>
          <div className={style.unitFeaturesContainer}>
            <div className={style.unitDetails}>
              <div className={style.unitDimensions}>
                {showDimensions
                  ? ''
                  : item?.dimensions?.width &&
                    item?.dimensions?.length && (
                      <>
                        {item?.dimensions?.width}
                        {locale === 'en' && '’'} x {item?.dimensions?.length}
                        {locale === 'en' && '’'}
                      </>
                    )}
              </div>
              <UnitFeatures />
            </div>
            <div className={style.unitPrice}>
              <div className={style.unitPriceText}>
                {displayPromotion || formatAsPrice(item?.rate, locale, false)}
              </div>
              {item?.rate && displayPromotion && (
                <div className="sv-dark-grey-medium-regular-text">
                  <del>{formatAsPrice(item?.rate, locale, false)}</del>
                </div>
              )}
              <span className="sv-dark-grey-small-regular-text text-nowrap">
                <FormattedMessage id="per week" />
              </span>
            </div>
          </div>
          <div className={style.unitReservationContainer}>
            <UnitFeatures />
            <div className={style.unitControllers}>
              <div className={style.unitPromotionDropdown}>
                {promotionList && promotionList.length > 0 && (
                  <PromotionDropdown
                    unit={item}
                    promotionError={promotionError}
                    locale={locale}
                    onSelect={handlePromotionSelect}
                    isMultiPromo={promotionList.length > 1}
                  />
                )}
              </div>
              <div className={style.unitCallback}>
                <button
                  data-bs-toggle={toggle}
                  data-bs-target={target}
                  className="btn dp-secondary-btn dp-secondary-btn-white"
                  type="button"
                  onClick={(event) => handleClick(event, item, 'callmeback')}
                >
                  <Image src={phone} alt="call-back" width="28" height="28" />
                </button>
              </div>
              <div className={style.unitReservationBtn}>
                <button
                  data-bs-toggle={toggle}
                  data-bs-target={target}
                  className="btn dp-primary-btn w-100 d-flex justify-content-center gap-2"
                  type="button"
                  onClick={(event) => handleClick(event, item, 'reserve')}
                >
                  <FormattedMessage id="facility-reserve" />
                  {!!item?.numAvailable &&
                    MINIMUM_UNITS < item?.numAvailable &&
                    item?.numAvailable < UNITS_LEFT && (
                      <div className="sv-red-small-text">
                        {item?.numAvailable}{' '}
                        <FormattedMessage id="Units-left" />
                      </div>
                    )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={show} onHide={handleClose} id="unitVideoModal">
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          {item?.videoUrl ? (
            <iframe src={item?.videoUrl} width="775" height="435" />
          ) : (
            <Image
              sizes="(max-width: 375px) 320px, (max-width: 576px) 576px, (max-width: 768px) 700px, (max-width: 992px) 700px, (max-width: 1280px) 700px"
              src={item?.image}
              alt="logo"
              className="img-fluid thumbnail"
              width="180"
              height="180"
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SingleUnitCard;
